import { FC, useState } from 'react';
import Modal from '@components/Modal';
import Button from '@components/DesignLibrary/Button';
import useNoodleApi from '@hooks/useNoodleApi';
import * as tsClient from '@tsClient';
import { Select, NumberInput } from '@/components/DesignLibrary/Atoms';
import { IncomeMetadata } from '@documentsApi/document-api-models';

import s from '../AddIncomeSourceModal/AddIncomeSourceModal.module.scss';
import {incomeSourceOptions} from '../AddIncomeSourceModal';

type FlatConsolidatedData = {
  id: string;
  "Employer":string|null,
  "Pay Cadence":string|null,
  "Pay Date":string|null,
  "Amount per Pay Period":number|null,
  "Overtime per Pay Period":number|null,
  "Tax, Medicare, and Social Security deductions":number|null,
  "Mandatory contributions for retirement plans":number|null,
  "Voluntary contributions for retirement plans":number|null,
  "Required repayments of retirement fund loans":number|null,
  "Insurance":number|null,
  "Domestic support obligations":number|null,
  "Union dues":number|null,
  "Other deductions":number|null,
  "Net Pay":number|null,
  "Total Gross Income": number |null,
  incomeSource?: IncomeMetadata['incomeSource'] | null;
};

type Props = {
  onClose: () => void;
  documentRequestUserId: string;
  refetchFiles: () => Promise<void>;
  row: FlatConsolidatedData & {
    rows: FlatConsolidatedData[];
  }
};

const EditNonEmploymentIncomeSourceModal: FC<Props> = ({ onClose, documentRequestUserId, refetchFiles, row }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [incomeSource, setIncomeSource] = useState<IncomeMetadata['incomeSource'] | null>(row.incomeSource ?? null);
  const [monthlyDollarValue, setMonthlyDollarValue] = useState<number| null>(row['Amount per Pay Period'] ?? null);

  const { getData: updateFn } = useNoodleApi(tsClient.documentRequests.updateDocumentRequestUserFile);

  const handleSubmit = async (): Promise<void> => {
    setIsSubmitting(true);
    const metadata = {
      incomeSource,
      monthlyDollarValue,
    };
    await updateFn({fileId:row.id, id: documentRequestUserId, metadata});
    setIsSubmitting(false);
    refetchFiles();
    onClose();
  };

  return (
    <Modal hideBottomInset title="Edit Income Source" onClose={onClose} drag>
      <div className={s.container}>
        <Select
          label="Income Source"
          value={incomeSource}
          onChange={val => setIncomeSource(val as IncomeMetadata['incomeSource'])}
          options={incomeSourceOptions.filter(option => option.key !== 'Employment')}
        />
        <NumberInput
          value={monthlyDollarValue}
          onChange={val =>
            setMonthlyDollarValue(val)
          }
          label="Monthly dollar value"
          min={0}
        />

        <Button loading={isSubmitting} variant="primary" size="md" fullWidth onClick={handleSubmit}>
         Submit
        </Button>
      </div>
    </Modal>
  );
};

export default EditNonEmploymentIncomeSourceModal;
